import * as React from 'react';
import * as Redux from 'react-redux';
import { allProfesionesAction } from '../ProfesionesAction';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';
import SelectAutocomplete from '../../../../widgets/SelectAutocomplete';

const SelectFieldProfesionesComponent = ({
  onChange,
  value,
  data,
  selects = [],
  isAutoComplete,
}) => {
  const dispatch = Redux.useDispatch();

  const profesionesStore = Redux.useSelector((state) => state.profesiones);

  const [profesiones, setProfesiones] = React.useState([]);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      profesionesStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setProfesiones(items);
    } else {
      if (data) {
        setProfesiones(data);
      } else {
        setProfesiones(profesionesStore.all);
      }
    }
  };

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && profesionesStore.all && profesionesStore.all.length === 0) {
        await allProfesionesAction(dispatch, null);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [selects]);

  const select = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.profesion.name}`}>
        {CONST.profesion.label}
      </InputLabel>
      <Select
        id={CONST.profesion.name}
        value={value}
        labelId={`label_${CONST.profesion.name}`}
        label={CONST.profesion.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {profesiones.map((el, index) => {
          return (
            <MenuItem key={`profesion-${index}`} value={el.id}>
              {el.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  const autoComplete = (
    <SelectAutocomplete
      id="combo-box-demo-profesiones"
      opt={profesiones}
      v={value}
      type={CONST.profesion.name}
      onChange={(event, newValue) => onChange(newValue?.id)}
      l="Profesiones"
    />
  );

  return isAutoComplete ? autoComplete : select;
};

export default SelectFieldProfesionesComponent;
